import { ENDPOINT } from 'api/endPoints/getScheduleQualityTrend';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    IScoreCardsWrapperProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { MEDIUM, SMALL } from 'components/Dashboards/Reporting/reportingConfig';

export const scheduleQualityTrend: IHashmapItemWithCustomProps<IScoreCardsWrapperProps> = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
            medium: MEDIUM,
        },
        widgetInitialSize: SMALL,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: false,
        },
        hideNarrativeEditor: false,
    },
    title: 'Schedule Quality Trend',
    id: 'schedule-quality-trend',
    componentKey: 'scheduleQualityTrend',
    endpoint: ENDPOINT,
};
